import { Homepage } from './src/Homepage';
import { Nav } from './src/Nav';
import { Hero } from './src/Hero';
import { Features } from './src/Features';
import { Pricing } from './src/Pricing';
import { Testimonials, TestimonialsItem } from './src/Testimonials';
import { PartnersBanner } from './src/PartnersBanner';
import { SignUpModal } from './src/SignUpModal';

Homepage.Nav = Nav;
Homepage.Hero = Hero;

Homepage.Features = Features;

Homepage.Pricing = Pricing;

Homepage.Testimonials = Testimonials;
Homepage.TestimonialsItem = TestimonialsItem;

Homepage.PartnersBanner = PartnersBanner;

Homepage.SignUpModal = SignUpModal;

export { Homepage };
